//App
import useForm from "../../../hooks/useForm";
import { RoleContextData, RoleProps } from "../../../../types/role";
import { RoleContext } from "../RoleContainer";

const useRole = (props: RoleProps) => {
  return useForm<RoleContextData, RoleProps>(RoleContext, props);
};

export default useRole;
